import React, { useEffect, useState, useCallback } from "react";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";

const REVIEWS = [
  { name: "Aisha Rahman", city: "Chennai", text: "The abaya I ordered is absolutely stunning — the fabric drapes so beautifully and feels premium. Adam's has been my family's trusted boutique for years, MashaAllah.", rating: 5 },
  { name: "Fatima Sheikh", city: "Bengaluru", text: "Elegant, modest and so comfortable. The quality is far beyond what I expected for the price. The champagne-toned hijabs are my absolute favourite now.", rating: 5 },
  { name: "Zainab Ali", city: "Chennai", text: "Ordered a jilbab set for Umrah and it was perfect — lightweight, breathable and beautifully stitched. Delivery was quick and the packaging felt luxurious.", rating: 5 },
  { name: "Mariam Yusuf", city: "Hyderabad", text: "Finally a boutique that understands modest fashion without compromising on style. Every piece feels thoughtfully designed. JazakAllah khair, Adam's!", rating: 5 },
  { name: "Khadija Noor", city: "Bengaluru", text: "The party-wear hijab I bought received so many compliments at a wedding. Rich colours, gorgeous finish. I've already placed my second order.", rating: 5 },
  { name: "Sumayya Iqbal", city: "Chennai", text: "Three generations of my family shop here. From everyday abayas to special occasions, the elegance and trust remain unmatched. Highly recommended.", rating: 5 },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const n = REVIEWS.length;
  const next = useCallback(() => setI((p) => (p + 1) % n), [n]);
  const prev = useCallback(() => setI((p) => (p - 1 + n) % n), [n]);

  useEffect(() => {
    const t = setInterval(next, 5500);
    return () => clearInterval(t);
  }, [next, i]);

  const r = REVIEWS[i];

  return (
    <section className="bg-beige/60 py-16 lg:py-24" data-testid="testimonials-section">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="overline mb-3">Loved by Our Community</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-espresso">What Our Customers Say</h2>

        <div className="relative mt-12 min-h-[240px] sm:min-h-[200px] flex items-center">
          <button onClick={prev} aria-label="Previous review" data-testid="review-prev" className="absolute left-0 lg:-left-4 z-10 w-10 h-10 rounded-full bg-ivory shadow-md flex items-center justify-center hover:bg-champagne transition-colors">
            <ChevronLeft className="w-5 h-5 text-espresso" />
          </button>

          <div key={i} className="flex-1 px-10 lg:px-14 fade-in-up" data-testid="review-slide">
            <Quote className="w-10 h-10 text-champagne/50 mx-auto mb-5" />
            <div className="flex justify-center gap-1 mb-5">
              {Array.from({ length: r.rating }).map((_, s) => <Star key={`s-${s}`} className="w-4 h-4 fill-champagne text-champagne" />)}
            </div>
            <p className="font-serif text-xl sm:text-2xl text-espresso leading-relaxed italic">"{r.text}"</p>
            <p className="mt-6 font-sans text-sm font-semibold tracking-wide text-espresso">{r.name}</p>
            <p className="font-sans text-xs text-champagne uppercase tracking-[0.2em] mt-0.5">{r.city}</p>
          </div>

          <button onClick={next} aria-label="Next review" data-testid="review-next" className="absolute right-0 lg:-right-4 z-10 w-10 h-10 rounded-full bg-ivory shadow-md flex items-center justify-center hover:bg-champagne transition-colors">
            <ChevronRight className="w-5 h-5 text-espresso" />
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {REVIEWS.map((_, d) => (
            <button key={`dot-${d}`} onClick={() => setI(d)} aria-label={`Go to review ${d + 1}`} data-testid={`review-dot-${d}`} className={`h-1.5 rounded-full transition-all duration-300 ${d === i ? "w-7 bg-champagne" : "w-1.5 bg-espresso/25 hover:bg-espresso/40"}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
